import { StepEvent } from '@samelogic/steps';
import { ConfigTreeNode } from '../models';
import { getDependencyConfigKeys } from './getDependencyConfigKeys';

/*
    three layer case
           ┌──────┐
           │ root │
           └──┬───┘
              │
        ┌─────┴─────┐
        │           │
      eventA      eventB
        │           │
      ┌─┴─┐       ┌─┴─┐
      │ A │       │ B │
      └─┬─┘       └───┘
        │
  ┌─────┴────┐
  │          │
eventA    eventA
  │          │
┌─┴──┐     ┌─┴──┐
│ A1 │     │ A2 │
└────┘     └────┘
 */
const rootStepConfig = {
  name: 'root',
  uses: ''
};
const aStepConfig = {
  name: 'a',
  uses: '',
  needs: {
    name: 'root',
    event: 'eventA'
  }
};
const a1StepConfig = {
  name: 'a1',
  uses: '',
  needs: {
    name: 'a',
    event: 'eventA'
  }
};
const a2StepConfig = {
  name: 'a1',
  uses: '',
  needs: {
    name: 'a',
    event: 'eventA'
  }
};
const bStepConfig = {
  name: 'b',
  uses: '',
  needs: {
    name: 'root',
    event: 'eventB'
  }
};

// expected tree nodes
const rootNode = {
  config: rootStepConfig,
  stepInstances: []
};

const aNode = {
  config: aStepConfig,
  stepInstances: [],
  parent: rootNode
};

const a1Node = {
  config: a1StepConfig,
  stepInstances: [],
  parent: aNode
};

const a2Node = {
  config: a2StepConfig,
  stepInstances: [],
  parent: aNode
};
const bNode = {
  config: bStepConfig,
  stepInstances: [],
  parent: rootNode
};

describe('getDependencyConfigKeys()', () => {
  type SuccessCase = {
    name: string;
    map: Map<string, ConfigTreeNode>;
    stepEvent: StepEvent;
    expected: string[];
  };
  const manyDepdendencies: SuccessCase = {
    name: 'when step event has many dependencies in the config tree',
    map: new Map([
      ['root', rootNode],
      ['a', aNode],
      ['a1', a1Node],
      ['a2', a2Node],
      ['b', bNode]
    ]),
    stepEvent: {
      stepName: 'a',
      event: 'eventA',
      data: {}
    },
    expected: ['a1', 'a2']
  };

  const singleDependency: SuccessCase = {
    name: 'when step event has a single dependency in the config tree',
    map: new Map([
      ['root', rootNode],
      ['a', aNode],
      ['a1', a1Node],
      ['a2', a2Node],
      ['b', bNode]
    ]),
    stepEvent: {
      stepName: 'root',
      event: 'eventA',
      data: {}
    },
    expected: ['a']
  };

  const noDependency: SuccessCase = {
    name: 'when step event has no dependencies in the config tree',
    map: new Map([
      ['root', rootNode],
      ['a', aNode],
      ['a1', a1Node],
      ['a2', a2Node],
      ['b', bNode]
    ]),
    stepEvent: {
      stepName: 'b',
      event: 'eventB',
      data: {}
    },
    expected: []
  };
  describe.each<SuccessCase>([manyDepdendencies, singleDependency, noDependency])(
    'success: $name',
    ({ map, stepEvent, expected }) => {
      it(`should get all the right keys for the dependencies`, () => {
        const actual = getDependencyConfigKeys(map, stepEvent);
        expect(actual).toEqual(expected);
      });
    }
  );
});
